import React from 'react';
import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

const RHFPhoneField = ({
  name,
  control,
  label,
  info,
  forceError,
  rules,
  ...rest
}) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field, fieldState: { error, invalid, isTouched } }) => (
      <TextField
        {...field}
        label={label}
        placeholder={label}
        error={((isTouched || forceError) && invalid) || !!error}
        helperText={(((isTouched || forceError) || !!error) && error?.message) || info}
        InputProps={{
          startAdornment: <InputAdornment position="start">+</InputAdornment>
        }}
        {...rest}
      />
    )}
  />
);

export default RHFPhoneField;
